import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadableClientsPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableClientsPage;
